"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _StretchMenuLayout = _interopRequireDefault(require("./StretchMenuLayout"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _StretchMenuLayout.default;
exports.default = _default;